import type { Component } from 'vue'
import { onMounted, shallowRef } from 'vue'

// lottie-web needs the DOM, so the player and its ~45 KB animation load on the client only
export function useLottie(loadAnimation: () => Promise<{ default: object }>) {
  const player = shallowRef<Component>()
  const animationData = shallowRef<object>()

  onMounted(async () => {
    try {
      const [lottie, data] = await Promise.all([import('vue3-lottie'), loadAnimation()])
      player.value = lottie.Vue3Lottie
      animationData.value = data.default
    } catch {
      // keep the spinner fallback when either chunk fails to load
    }
  })

  return { player, animationData }
}
